import { createAction, props } from '@ngrx/store';
import { Facet, PLPParams } from '@b2b/features/product/core/utilities/product-list.model';
import { Product } from '@b2b/features/product/core/utilities/product.model';

// ===== PRODUCT =====
// GET
export const GET_PRODUCT_LIST = '[PRODUCT_LIST]: GET';

export const getProductList = createAction(GET_PRODUCT_LIST, props<{ params: PLPParams }>());

// SET
export const SET_PRODUCT_LIST = '[PRODUCT_LIST]: SET';
export const SET_SPECIFIC_PRODUCT_ON_LIST = '[SET_SPECIFIC_PRODUCT_ON_LIST]: SET';
export const SET_PRODUCT_LIST_SUCCESS = '[PRODUCT_LIST]: SET - SUCCESS';
export const SET_PRODUCT_LIST_FAIL = '[PRODUCT_LIST]: SET - FAIL';
export const CLEAR_PRODUCT_LIST = '[PRODUCT_LIST]: CLEAR';

export const setSpecificProductOnList = createAction(
  SET_SPECIFIC_PRODUCT_ON_LIST,
  props<{ product: Product; index: number }>(),
);
export const setProductList = createAction(SET_PRODUCT_LIST, props<{ products: Product[] }>());
export const setProductListSuccess = createAction(SET_PRODUCT_LIST_SUCCESS, props<{ data: any }>());
export const setProductListFail = createAction(SET_PRODUCT_LIST_FAIL, props<{ erroMessage: string }>());
export const clearProductList = createAction(CLEAR_PRODUCT_LIST);

export const CLEAR_PRODUCT_LIST_FACET_APPLIED = '[PRODUCT_LIST_FACET_APPLIED]: CLEAR';

export const setProductListFacetApplied = createAction(
  CLEAR_PRODUCT_LIST_FACET_APPLIED,
  props<{ appliedFacets: Facet[] }>(),
);
